"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Evented = void 0;
const class_transformer_1 = require("class-transformer");
const util_1 = require("../util");
class Evented {
    constructor(id) {
        this.id = id;
        this.version = 0;
        this.events = [];
        this.doCheckpoint();
    }
    setId(id) {
        this.id = id;
    }
    getId() {
        return this.id;
    }
    getVersion() {
        return this.version;
    }
    getEvents() {
        this.events.sort((a, b) => {
            if (a.version > b.version) {
                return 1;
            }
            if (a.version < b.version) {
                return -1;
            }
            return 0;
        });
        return this.events;
    }
    loadState(events, reload = true) {
        if (reload) {
            this.events = [];
            this.version = 0;
        }
        for (let e of events) {
            this.getHandler(e.name)(e);
            this.version = e.version;
            this.events.push(e);
        }
    }
    updateState(event) {
        event.sourceId = this.id;
        event.version = this.version + 1;
        this.doCheckpoint();
        this.getHandler(event.name)(event);
        this.version = event.version;
        this.events.push(event);
    }
    lastCheckpoint() {
        return this.checkpoint;
    }
    setCheckpointManually(utcms) {
        this.checkpoint = utcms;
    }
    currentCheckpoint() {
        return util_1.Timing.getUtcMsNow();
    }
    getHandler(name) {
        util_1.logger.trace(`handler name: ${name}`);
        let handlerName = name;
        if (name.indexOf(':') > 0) {
            handlerName = name
                .split(':')
                .map((part) => {
                return part.charAt(0).toUpperCase() + part.slice(1);
            })
                .join('');
        }
        return this[`on${handlerName}`].bind(this);
    }
    doCheckpoint() {
        this.checkpoint = util_1.Timing.getUtcMsNow();
    }
}
__decorate([
    class_transformer_1.Exclude({ toPlainOnly: true }),
    __metadata("design:type", Array)
], Evented.prototype, "events", void 0);
exports.Evented = Evented;
//# sourceMappingURL=EventSourced.js.map